<script>
import { mapActions } from "vuex";
import i18n from "@/plugins/i18n";

import internalAnswers from "../results/components/internal-answers.vue";
import externalAnswers from "../results/components/external-answers.vue";
import materialityMatrix from "../results/components/materiality-matrix.vue";
import mixed from "../results/components/mixed.vue";
import wordCloud from "../results/components/WordCloud_su2.vue"

import d_internalAnswers from "../results/components/d_internal-answers.vue";
import d_externalAnswers from "../results/components/d_external-answers.vue";
import d_mixed from "../results/components/d_mixed.vue";
import d_materialityMatrix from "../results/components/d_materiality-matrix.vue";

import internal_others from "../results/components/internal-answers_others.vue";
import internal_managers from "../results/components/internal-answers_managers.vue";
import external_others from "../results/components/external-answers_others.vue";
import external_managers from "../results/components/external-answers_managers.vue";
import external_customers from "../results/components/external-answers_customers.vue";

import d_internal_others from "../results/components/d_internal-answers_others.vue";
import d_internal_managers from "../results/components/d_internal-answers_managers.vue";
import d_external_others from "../results/components/d_external-answers_others.vue";
import d_external_managers from "../results/components/d_external-answers_managers.vue";
import d_external_customers from "../results/components/d_external-answers_customers.vue";

export default {
  name: "SDG Alignment Survey Results",
  components: {
    internalAnswers,
    externalAnswers,
    materialityMatrix,
    mixed,
    wordCloud,
    d_internalAnswers,
    d_externalAnswers,
    d_mixed,
    d_materialityMatrix,
    internal_others,
    internal_managers,
    external_others,
    external_managers,
    external_customers,
    d_internal_others,
    d_internal_managers,
    d_external_others,
    d_external_managers,
    d_external_customers
  },
  data() {
    return {
      textResultsSU2: [],
      loadingTextResultsSU2: false,
      tabsControl: 0,
      textResultsFields: [
        {
          key: "firstname",
          label: i18n.t("su2Results.header.firstname"),
        },
        {
          key: "surname",
          label: i18n.t("su2Results.header.surname"),
        },
        {
          key: "email",
          label: "Email",
        },
        {
          key: "role_name",
          label: i18n.t("su2Results.header.roleName"),
        },
        {
          key: "text_answer",
          label: i18n.t("su2Results.header.textAnswer"),
        },
        {
          key: "completed_on",
          label: i18n.t("su2Results.header.completedOn"),
        },
      ],
      su1PieModal: false,
      su2Surveys: [],
      selectedSurveyModal: false,
      selectedSurveyID: "",
      internalAnswersModal: false,
      externalAnswersModal: false,
      internalAndExternalAnswer: false,
      materialityMatrixModal: false,
      wordCloudModal: false,
      selectedSurveyName: "",
      loading: false,

      internalOthersModal: false,
      internalManagersModal: false,
      externalOthersModal: false,
      externalManagersModal: false,
      externalCustomersModal: false,

      graphs: true,
      texts: false,

      missingChecks: null,

      emptyResults: []
    };
  },

  watch: {
    selectedSurveyID() {
      const foundObject = this.su2Surveys.find(
        (obj) => obj.su2_survey_id === this.selectedSurveyID
      );
      this.selectedSurveyName = foundObject.su2_survey_name;
      if (this.selectedSurveyID) {
        this.selectedSurveyModal = false;
        this.textsResults();
      }
    },

    texts(newVal) {
      if (newVal == true) {
        this.textsResults();
      }
    }
  },
  methods: {
    ...mapActions("results", [
      "getSu2SurveyResultsForExcel",
    ]),
    ...mapActions("auditor", [
      "getSU2Surveys",
      "getSU2SurveyResults",
      "getLastSU2Survey",
    ]),
    ...mapActions("reports", ["getGraphImagesInfo"]),

    getMissingGraphs(){
      const params = {
        company_id: Number(sessionStorage.getItem('audited_company_id')),
      }
      
      this.getGraphImagesInfo(params)
        .then( res => {
          this.missingChecks = res.data.check_images_exist;
        })
    },

    // get su2 surveys
    getMySurveys() {
      this.su2Surveys = [];
      const params = {
        company_id: Number(sessionStorage.getItem('audited_company_id')),
        is_deleted: false,
        is_approved: true,
      };
      this.getSU2Surveys(params)
        .then((res) => {
          res.data.forEach((element) => {
            this.su2Surveys.push(element);
          });
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },
    openingSurvey(){
      this.loading= true;
      const params = {
        company_id: Number(sessionStorage.getItem('audited_company_id')),
        created_by: parseInt(this.$user.user_id),
        is_approved: true,
      };

      this.getLastSU2Survey(params)
        .then( res => {
          this.selectedSurveyID = res.data.su2_survey_id;
          this.selectedSurveyName = res.data.su2_survey_name;
        })
        .catch( err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    // su2 text results
    textsResults() {
      this.textResultsSU2 = [];
      this.loadingTextResultsSU2 = true;
      let params = {
        su2_survey_id: this.selectedSurveyID,
        company_id: Number(sessionStorage.getItem('audited_company_id')),
        created_by: parseInt(this.$user.user_id),
      };
      this.getSU2SurveyResults(params)
        .then((res) => {
          res.data.forEach((element) => {
            this.textResultsSU2.push(element);
          });
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        })
        .finally(() => {
          this.loadingTextResultsSU2 = false;
        });
    },
    selectSurvey() {
      this.selectedSurveyModal = true;
    },

    handleEmptyResult(name) {
      if (this.emptyResults.some(x => x == name) == false) {
        console.log("!!!")
        this.emptyResults.push(name);
      }
    },

    handleMyTabs(clickedTab, event){
      if (clickedTab == 0){
        this.graphs = true;
        this.texts = false;
      }
      if (clickedTab == 1){
        this.graphs = false;
        this.texts = true;
      }
    },
  },
  mounted(){
    this.getMySurveys();
    this.openingSurvey();
    this.getMissingGraphs();
    this.textsResults();
  }
};
</script>

<template>
  <div class="p-3">
    <div v-if="loading" class="spinner-container">
      <b-spinner variant="success" label="Loading..."></b-spinner>
    </div>
    <div v-else>
    <div v-if="!selectedSurveyModal">
      <b-button class="m-1 squared-select"
        :variant="selectedSurveyName ? 'success' : 'danger'"
        style="border: 0; max-height: 35px; min-width: 8em"
        @click="selectSurvey()"
      >
        {{ selectedSurveyName ? selectedSurveyName : $t('su1Results.nothing')}}  
      </b-button>
      <b-button class="m-1 squared-select"
        variant="info" style="max-height: 35px;"
        @click="downloadExcel()"
        >{{ $t("su1Results.createExcel") }}
        <b-icon icon="file-earmark-excel"> </b-icon
      ></b-button>
      <br /><br /><br />

      <div class="tab-rounded">
        <div class="tab-btn" :class="{'active': graphs}"
          @click="handleMyTabs(0, $event)"
        >
          {{ $t('su1Results.graphResults') }}
        </div>
        <div class="tab-btn" :class="{'active': texts}" 
          @click="handleMyTabs(1, $event)"
        >
          {{ $t('su1Results.textResults') }}
        </div>
      </div>

      <div v-if="graphs">

        <div class="row">
            <div :class="{'unsaved-graph': !missingChecks.su2_internalanswers}" class="chart-item m-3 col custom-rounded" style="background: #023047;" > <!--  -->
              <a @click="internalAnswersModal = true" id="internal-answers">
                <div class="content row text-center justify-content-center mt-3 p-3">
                  <div class="title row col-12 d-flex justify-content-center">{{ $t("su2Results.resultsPage.page.internal.title") }}</div>
                  <br><br>
                  <p class="row col-12 text-center p-3 d-flex justify-content-center">{{ $t("su2Results.resultsPage.page.internal.description") }}</p>
                </div>
                <div class="chartimg col-12 mx-auto pl-3 pr-3 pb-3">
                  <d_internalAnswers :selectedSurveyID="selectedSurveyID"/>
                </div>
              </a>
            </div>
            <div :class="{'unsaved-graph': !missingChecks.su2_externalanswers}" class="chart-item m-3 col custom-rounded" style="background: #023047;" > <!--  -->
              <a @click="externalAnswersModal = true" id="external-answers">
                <div class="content row text-center justify-content-center mt-3 p-3">
                  <div class="title row col-12 d-flex justify-content-center">{{ $t("su2Results.resultsPage.page.external.title") }}</div>
                  <br><br>
                  <p class="row col-12 text-center p-3 d-flex justify-content-center">{{ $t("su2Results.resultsPage.page.external.description") }}</p>
                </div>
                <div class="chartimg col-12 mx-auto pl-3 pr-3 pb-3">
                  <d_externalAnswers :selectedSurveyID="selectedSurveyID"/>
                </div>
              </a>
            </div>
            <div :class="{'unsaved-graph': !missingChecks.su2_int_ext_bar}" class="chart-item m-3 col custom-rounded" style="background: #023047;" > <!--  -->
              <a @click="internalAndExternalAnswer = true" id="mixed-answers">
                <div class="content row text-center justify-content-center mt-3 p-3">
                  <div class="title row col-12 d-flex justify-content-center">
                    {{ $t("su2Results.resultsPage.page.mixed.title") }}
                  </div>
                  <br><br>
                  <p class="row col-12 text-center p-3 d-flex justify-content-center">{{ $t("su2Results.resultsPage.page.mixed.description") }}</p>
                </div>
                <div class="chartimg col-12 mx-auto pl-3 pr-3 pb-3">
                  <d_mixed :selectedSurveyID="selectedSurveyID"/>
                </div>
              </a>
            </div>
          </div>

          <div class="row">
            <div :class="{'unsaved-graph': !missingChecks.su2_int_managers}" class="chart-item m-3 col custom-rounded" style="background: #023047;" v-show="emptyResults.some(x => x == 'internal_managers') == false"> <!--  -->
              <a @click="internalManagersModal = true" id="internal-managers-answers">
                <div class="content row text-center justify-content-center mt-3 p-3">
                  <div class="title row col-12 d-flex justify-content-center">{{ $t("su2Results.resultsPage.page.internal_mng.title") }}</div>
                  <br><br>
                  <p class="row col-12 text-center p-3 d-flex justify-content-center">{{ $t("su2Results.resultsPage.page.internal.description") }}</p>
                </div>
                <div class="chartimg col-12 mx-auto pl-3 pr-3 pb-3">
                  <d_internal_managers :selectedSurveyID="selectedSurveyID" @onEmptyResult="handleEmptyResult"/>
                </div>
              </a>
            </div>

            <div :class="{'unsaved-graph': !missingChecks.su2_int_others}" class="chart-item m-3 col custom-rounded" style="background: #023047;" v-show="emptyResults.some(x => x == 'internal_others') == false"> <!--  -->
              <a @click="internalOthersModal = true" id="internal-others-answers">
                <div class="content row text-center justify-content-center mt-3 p-3">
                  <div class="title row col-12 d-flex justify-content-center">{{ $t("su2Results.resultsPage.page.internal_oth.title") }}</div>
                  <br><br>
                  <p class="row col-12 text-center p-3 d-flex justify-content-center">{{ $t("su2Results.resultsPage.page.internal.description") }}</p>
                </div>
                <div class="chartimg col-12 mx-auto pl-3 pr-3 pb-3">
                  <d_internal_others :selectedSurveyID="selectedSurveyID" @onEmptyResult="handleEmptyResult"/>
                </div>
              </a>
            </div>

            <div :class="{'unsaved-graph': !missingChecks.su2_ext_customers}" class="chart-item m-3 col custom-rounded" style="background: #023047;" v-show="emptyResults.some(x => x == 'external_customers') == false"> <!--  -->
              <a @click="externalCustomersModal = true" id="external-customer-answers">
                <div class="content row text-center justify-content-center mt-3 p-3">
                  <div class="title row col-12 d-flex justify-content-center">{{ $t("su2Results.resultsPage.page.external_cst.title") }}</div>
                  <br><br>
                  <p class="row col-12 text-center p-3 d-flex justify-content-center">{{ $t("su2Results.resultsPage.page.external.description") }}</p>
                </div>
                <div class="chartimg col-12 mx-auto pl-3 pr-3 pb-3">
                  <d_external_customers :selectedSurveyID="selectedSurveyID" @onEmptyResult="handleEmptyResult"/>
                </div>
              </a>
            </div>
            
            
            
          </div>

          <div class="row">
            <div :class="{'unsaved-graph': !missingChecks.su2_ext_managers}" class="chart-item m-3 col custom-rounded" style="background: #023047;" v-show="emptyResults.some(x => x == 'external_managers') == false"> <!--  -->
              <a @click="externalManagersModal = true" id="external-manager-answers">
                <div class="content row text-center justify-content-center mt-3 p-3">
                  <div class="title row col-12 d-flex justify-content-center">{{ $t("su2Results.resultsPage.page.external_supp.title") }}</div>
                  <br><br>
                  <p class="row col-12 text-center p-3 d-flex justify-content-center">{{ $t("su2Results.resultsPage.page.external.description") }}</p>
                </div>
                <div class="chartimg col-12 mx-auto pl-3 pr-3 pb-3">
                  <d_external_managers :selectedSurveyID="selectedSurveyID"  @onEmptyResult="handleEmptyResult"/>
                </div>
              </a>
            </div>

            <div :class="{'unsaved-graph': !missingChecks.su2_ext_others}" class="chart-item m-3 col custom-rounded" style="background: #023047;" v-show="emptyResults.some(x => x == 'external_others') == false"> <!--  -->
              <a @click="externalOthersModal = true" id="external-others-answers">
                <div class="content row text-center justify-content-center mt-3 p-3">
                  <div class="title row col-12 d-flex justify-content-center">{{ $t("su2Results.resultsPage.page.external_oth.title") }}</div>
                  <br><br>
                  <p class="row col-12 text-center p-3 d-flex justify-content-center">{{ $t("su2Results.resultsPage.page.external.description") }}</p>
                </div>
                <div class="chartimg col-12 mx-auto pl-3 pr-3 pb-3">
                  <d_external_others :selectedSurveyID="selectedSurveyID" @onEmptyResult="handleEmptyResult"/>
                </div>
              </a>
            </div>

            <div :class="{'unsaved-graph': !missingChecks.su2_materialityMatrix}" class="chart-item m-3 col custom-rounded" style="background: #023047;" > <!--  -->
              <a @click="materialityMatrixModal = true" id="materiality-matrix">
                <div class="content row text-center justify-content-center mt-3 p-3">
                  <div class="title row col-12 d-flex justify-content-center">{{ $t("su2Results.resultsPage.page.materialityMatrix.title") }}</div>
                  <br><br>
                  <p class="row col-12 text-center p-3 d-flex justify-content-center">{{ $t("su2Results.resultsPage.page.materialityMatrix.description") }}</p>
                </div>
                <div class="chartimg col-12 mx-auto pl-3 pr-3 pb-3">
                  <d_materialityMatrix :selectedSurveyID="selectedSurveyID"/>
                </div>
              </a>
            </div>
          </div>

          <div class="row d-flex justify-content-center">
            <div :class="{'unsaved-graph': !missingChecks.su2_wordcloud}" class="chart-item m-3 col-6 custom-rounded" style="background: #023047;" > <!--  -->
              <a @click="wordCloudModal = true" id="word-cloud">
                <div class="content row text-center justify-content-center mt-3 p-3">
                  <div class="title row col-12 d-flex justify-content-center">
                    {{ $t("su2Results.resultsPage.page.wordCloud.title") }}
                  </div>
                  <p class="row col-12 text-center p-3 d-flex justify-content-center">{{ $t("su2Results.resultsPage.page.wordCloud.description") }}</p>
                  <div class="chartimg col-6 mx-auto pl-3 pr-3 pb-3 d-flex justify-content-center">
                    <img src="/images/foul.png" alt="" />
                  </div>
                </div>
              </a>
            </div>
          </div>

      </div>

      <div v-if="texts">

        <b-table
            responsive
            show-empty
            :busy="loadingTextResultsSU2"
            hover
            :fields="textResultsFields"
            :items="textResultsSU2"
          >
            <template #empty="scope">
              <div style="text-align: center; font-size: 20px">
                <span>
                  {{ $t("noData.text") }} <b-icon icon="emoji-frown"></b-icon
                ></span>
              </div>
            </template>
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(completed_on)="data">
              <span>
                {{ data.value | dateFormat }}
              </span>
            </template>
          </b-table>

      </div>
    </div>
    </div>


    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      hide-header
      v-model="selectedSurveyModal"
      centered
    >
      <b-container class="bv-example-row">
        <b-row class="text-center">
          <b-col cols="12">
            <b-form-group :label="$t('su1Results.infoTitle')">
              <b-form-select
                :label="$t('registerForm.modalİnputs.companyId')"
                v-model="selectedSurveyID"
                :options="su2Surveys"
                value-field="su2_survey_id"
                text-field="su2_survey_name"
              ></b-form-select> </b-form-group
          ></b-col>
          <b-col cols="12">
            <b-button
              style="float: right"
              size="sm"
              variant="danger"
              @click="selectedSurveyModal=false"
            >
              {{ $t("su1Results.giveup") }}
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>

    <b-modal
      hide-header
      hide-footer
      v-model="internalAnswersModal"
      size="xl"
      centered
    >
      <div class="modal-content">
        <div class="background-image"></div>
        <b-container class="bv-example-row">
          <b-row class="text-center">
            <b-col cols="12" id="screenshot-area-internal-answers">
              <internal-answers
                ref="internalcontainer"
                :selectedSurveyID="selectedSurveyID"
              ></internal-answers>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-modal>
    <b-modal
      hide-header
      hide-footer
      v-model="internalOthersModal"
      size="xl"
      centered
    >
      <div class="modal-content">
        <div class="background-image"></div>
        <b-container class="bv-example-row">
          <b-row class="text-center">
            <b-col cols="12" id="screenshot-area-internal-others-answers">
              <internal_others
                ref="intotherscontainer"
                :selectedSurveyID="selectedSurveyID"
              ></internal_others>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-modal>
    <b-modal
      hide-header
      hide-footer
      v-model="internalManagersModal"
      size="xl"
      centered
    >
      <div class="modal-content">
        <div class="background-image"></div>
        <b-container class="bv-example-row">
          <b-row class="text-center">
            <b-col cols="12" id="screenshot-area-internal-managers-answers">
              <internal_managers
                ref="intmanagerscontainer"
                :selectedSurveyID="selectedSurveyID"
              ></internal_managers>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-modal>

    <b-modal
      hide-header
      hide-footer
      v-model="externalAnswersModal"
      size="xl"
      centered
    >
      <div class="modal-content">
        <div class="background-image"></div>
        <b-container class="bv-example-row">
          <b-row class="text-center">
            <b-col cols="12" id="screenshot-area-external-answers">
              <external-answers
                ref="externalcontainer"
                :selectedSurveyID="selectedSurveyID"
              ></external-answers>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-modal>
    <b-modal
      hide-header
      hide-footer
      v-model="externalOthersModal"
      size="xl"
      centered
    >
      <div class="modal-content">
        <div class="background-image"></div>
        <b-container class="bv-example-row">
          <b-row class="text-center">
            <b-col cols="12" id="screenshot-area-external-others-answers">
              <external_others
                ref="extotherscontainer"
                :selectedSurveyID="selectedSurveyID"
              ></external_others>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-modal>
    <b-modal
      hide-header
      hide-footer
      v-model="externalManagersModal"
      size="xl"
      centered
    >
      <div class="modal-content">
        <div class="background-image"></div>
        <b-container class="bv-example-row">
          <b-row class="text-center">
            <b-col cols="12" id="screenshot-area-external-manager-answers">
              <external_managers
                ref="extmanagerscontainer"
                :selectedSurveyID="selectedSurveyID"
              ></external_managers>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-modal>
    <b-modal
      hide-header
      hide-footer
      v-model="externalCustomersModal"
      size="xl"
      centered
    >
      <div class="modal-content">
        <div class="background-image"></div>
        <b-container class="bv-example-row">
          <b-row class="text-center">
            <b-col cols="12" id="screenshot-area-external-customer-answers">
              <external_customers
                ref="extcustomerscontainer"
                :selectedSurveyID="selectedSurveyID"
              ></external_customers>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-modal>

    <b-modal
      hide-header
      hide-footer
      v-model="internalAndExternalAnswer"
      size="xl"
      centered
    >
      <div class="modal-content">
        <div class="background-image"></div>
        <b-container class="bv-example-row">
          <b-row class="text-center">
            <b-col cols="12" id="screenshot-area-mixed-answers">
              <mixed
                ref="mixedcontainer"
                :selectedSurveyID="selectedSurveyID"
              ></mixed>
            </b-col>
          </b-row>
          <br />
        </b-container>
      </div>
    </b-modal>

    <b-modal
        hide-header
        hide-footer
        v-model="wordCloudModal"
        size="lg"
        centered
      >
        <div class="modal-content">
          <div class="background-image"></div>
          <b-container class="bv-example-row">
            <b-row class="text-center">
              <b-col cols="12" id="screenshot-area-word-cloud">
                <word-cloud
                  :selectedSurveyID="selectedSurveyID"
                  ref="wordcloudcontainer"
                ></word-cloud>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </b-modal>

    <b-modal
      hide-header
      hide-footer
      v-model="materialityMatrixModal"
      size="xl"
      centered
    >
      <div class="modal-content">
        <b-container class="bv-example-row">
          <b-row class="text-center">
            <b-col cols="12" id="screenshot-area-materiality-matrix">
              <materiality-matrix
                ref="mmatrixcontainer"
                :selectedSurveyID="selectedSurveyID"
              ></materiality-matrix>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>

.tab-rounded {
  border-radius: 200px;
  overflow: hidden;
  border: medium solid var(--sustainfinity-navy);

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  margin-bottom: 1em;
}

.tab-btn {
  background-color: whitesmoke;
  color: var(--sustainfinity-navy);
  width: 100%;
  text-align: center;
  padding: .25em;

  transition: all 150ms;
  cursor: pointer;
}

.tab-btn:hover {
  background-color: lightgray;
}

.tab-btn.active {
  background-color: var(--sustainfinity-navy);
  color: whitesmoke;
  pointer-events: none;
}

.save-graph-button{
  position: absolute;
  top: 0;
  right: 0;
  margin: .5em;

  max-width: fit-content;
  max-height: fit-content;

  z-index: 99;
}

.unsaved-graph{
  filter: drop-shadow(0 0 5px red);
}

.modal-content {
  position: relative;
  border: none;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("/images/sustainfinity-logo.png");
  background-repeat: no-repeat; 
  background-size: 100% 100%; 
  opacity: 0.15;
}

.background-image::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.1);
  z-index: -1;
}

table.text-center * {
  text-align: center;
}

@import "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css";
@import url("https://fonts.googleapis.com/css?family=Lato:300,400,700,900&subset=latin-ext");

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

img {
  width: 80%;
  vertical-align: middle;
}

.chart-item a {
  color: #333;
  background: var(--sustainfinity-navy) !important;
  cursor: pointer;
  font-family: "Lato", sans-serif;
  font-size: 16px;
}

.chart-item {
  box-shadow: 0 0 1em .5em gray;
}

.title{
  color: white !important;
  font-size: 24px;
}
.content > p{
  color: white !important;
}

.squared-select{
  margin-left: .66em !important;
  margin-right: .66em !important;
  text-align: center;

  cursor: pointer;

  border: none;
  outline: none;
  
  color: white;
  font-weight: bold;
  font-size: .9em;

  filter: drop-shadow(0 0 .33em rgb(101, 101, 101));
}
</style>